export const LEGACY_PERSONAS = ['default', 'accessible'] as const;
